import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './AddressPopover.module.css'

const AddressPopoverContent = () => {
  const { t } = useTranslation()

  return (
    <div className={`display-flex gap-l padding-m ${styles.container}`}>
      <span className={'font-body-medium-regular'}>{t('wizard.screen.address.popover.description1')}</span>
      <div>
        <strong>{t('wizard.screen.address.popover.description2.header')}</strong>{' '}
        <span>{t('wizard.screen.address.popover.description2.content')}</span>
      </div>
    </div>
  )
}
export default AddressPopoverContent
